<template>
  <div class="main">
    <HeaderTitle title="Kuota"></HeaderTitle>
    <MainContent>
      <div class="pt-5 pb-5">
        <div class="pb-3">
          <span
            class="bg-blue-100 text-blue-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded-sm dark:bg-blue-900 dark:text-blue-300"
            >{{ first }} - {{ last }}</span
          >
        </div>

        <table
          class="w-full border-collapse border border-gray-400 text-center text-sm"
        >
          <thead>
            <tr class="bg-white">
              <th class="border border-gray-400 py-3">Jumlah Kuota</th>
              <th class="border border-gray-400 py-3">Sisa Kuota</th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-white">
              <td class="border border-gray-400 py-4">
                {{ kuotabyweek.loading ? 0 : 3 }}
              </td>
              <td class="border border-gray-400 py-4">
                {{ sisa }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </MainContent>
  </div>
</template>
<script>
import HeaderTitle from "@/components/HeaderTitle.vue";
import MainContent from "@/components/MainContent.vue";
import moment from "moment";
import { useKuotaStore, useAuthStore } from "@/store";
import { storeToRefs } from "pinia";
import { onMounted, ref } from "vue";

export default {
  components: {
    HeaderTitle,
    MainContent,
  },
  setup() {
    const kuotaStore = useKuotaStore();
    const { kuotabyweek } = storeToRefs(kuotaStore);
    const authStore = useAuthStore();
    const { user } = storeToRefs(authStore);

    const first = moment().startOf("week").format("DD MMM YYYY");
    const last = moment().endOf("week").format("DD MMM YYYY");

    const sisa = ref(0);

    const cekKuotaMingguan = async () => {
      await kuotaStore.cekKuotaMingguan(user.value.id);

      sisa.value = 3 - kuotabyweek.value.count;
    };

    onMounted(() => {
      cekKuotaMingguan();
    });

    return {
      first,
      last,
      kuotabyweek,
      sisa,
    };
  },
};
</script>
<style></style>
